import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { KB_SOURCE } from "util/constants";

import axios from "@/configs/axios";

interface DeleteBlobsResult {
  data: any;
  status: number;
}

export const usePostDeleteBlobs = (): UseMutationResult<DeleteBlobsResult, Error, string[]> => {
  const callDeleteBlobs = useCallback(async (request: string[]): Promise<DeleteBlobsResult> => {
    try {
      const url = `${process.env.REACT_APP_SERVER_HOST}/deleteBlob/?source=${KB_SOURCE}`;
      const response = await axios.delete(url, {
        data: {
          blob_names: request,
          source: KB_SOURCE,
        },
      });
      return response;
    } catch {
      return { status: 500, data: [] };
    }
  }, []);

  return useMutation<DeleteBlobsResult, Error, string[]>({
    mutationFn: callDeleteBlobs,
  });
};
